export const GET_ACCOUNT_TYPE_REQUEST = "GET_ACCOUNT_TYPE_REQUEST";
export const GET_ACCOUNT_TYPE_SUCCESS = "GET_ACCOUNT_TYPE_SUCCESS";
export const GET_ACCOUNT_TYPE_FAILURE = "GET_ACCOUNT_TYPE_FAILURE";
export const GET_ACCOUNT_TYPE_RESET = "GET_ACCOUNT_TYPE_RESET";
export const getAccountTypeRequest = (payload) => ({
    type: GET_ACCOUNT_TYPE_REQUEST,
    payload,
});
export const getAccountTypeSuccess = (payload) => ({
    type: GET_ACCOUNT_TYPE_SUCCESS,
    payload,
});
export const getAccountTypeFailure = (payload) => ({
    type: GET_ACCOUNT_TYPE_FAILURE,
    payload,
});
export const getAccountTypeReset = () => ({
    type: GET_ACCOUNT_TYPE_RESET,
});
